import React, { Component, Fragment } from 'react';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { StyleSheet, css } from 'aphrodite';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ImageUploader } from './ImageUploader';
import { DocumentUploader } from './DocumentUploader';
import { RichtextEditor } from './RichtextComponent/RichtextEditor';
import { AppTheme } from '../../styles/AppTheme';
import TextField from '@material-ui/core/TextField';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import moment from 'moment-timezone'
import MomentUtils from '@date-io/moment'
import { AppConfig } from '../../AppConfig';
import { MuiPickersUtilsProvider, TimePicker } from 'material-ui-pickers'
import { DatePicker } from 'material-ui-pickers'
import { DateTimePicker } from 'material-ui-pickers'
import { CustomDynamicFormStyles } from '../../styles/CustomStyles';
import { deleteFormField } from '../data/data';
import { AppButton } from './AppButton';
import { InputAdornment } from '@material-ui/core';
import ImageIcon from '@material-ui/icons/Image';
import { ColourPicker } from './ColourPicker';

export class DynamicForm extends Component {
  constructor(props) {
    super(props);
    this.submitOnlyChanges = false
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.doAction = this.doAction.bind(this);

    this.state = {
      success: true,
      message: '',
      inProcess: false,
      formFieldUpdateProgress: null
    };
    this.locations = {}
    this.setFormState();
    moment.tz.setDefault(AppConfig.DEFAULT_ZONEINFO)
  }

  setFormState() {
    this.fields = this.props.formDefinition.steps[0].fields;
    for (let i = 0; i < this.fields.length; i++) {
      const current = this.fields[i];
      if (current.type === 'radio') {
        current.multiSelect = false
        if (current.value && Array.isArray(current.value) && current.value.length > 0) {
          // incase the cloud stores a radio as singleton array
          current.value = current.value[0]
        }
      } else if (current.type === 'check_box') {
        current.multiSelect = true
      }
      if (this.props.formDefinition.formType === 'add' && current.defaultValue) {
        current.value = current.defaultValue
      }
      if (!current.value) {
        if (current.multiSelect) {
          current.value = [];
        } else {
          current.value = '';
        }
      }
      if (!this.state[current.key]) {
        this.state[current.key] = current.value;
        if (current.valueDisplayScale && this.state[current.key]) {
          this.state[current.key] = (this.state[current.key] / current.valueDisplayScale).toFixed(2)
        }
      }
      this.fields[i].valid = true;
      // if (current.imageUpload || current.documentUpload) { //TODO: why whas this introduced? commenting now since we are honouring 'disabled' attributes now
      //   current.disabled = true
      // }
    }
    this.previousState = this.state;
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const id = target.id;
    this.fields.find(o => o.key === id).valid = true;
    this.setState({
      [id]: value
    });
  }

  handleDeleteFieldChange = (event) => {
    const target = event.target;
    const value = target.value;
    const id = target.id;
    this.setState({
      [id]: value
    });
  }

  handleRichtextInputChange = (value, id) => {
    this.setState({
      [id]: value
    });
  }

  handleSelectChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.fields.find(o => o.key === name).valid = true;
    this.setState({
      [name]: value
    });
  }

  handleUploadSuccess(fieldKey, signedUploadInfo) {
    const field = this.fields.find(o => o.key === fieldKey);
    if (field) {
      field.valid = true
      if(signedUploadInfo.link) field.link = signedUploadInfo.link
      if(field.imageUpload && field._inputImageHeightName && field._inputImageWidthName &&
        signedUploadInfo.height && signedUploadInfo.width) {
        this.setState({
          [fieldKey]: signedUploadInfo.fields.key,
          [field._inputImageHeightName]: signedUploadInfo.height,
          [field._inputImageWidthName] : signedUploadInfo.width
        })
      } else if(field.documentUpload && field._inputVideoHeightName && field._inputVideoWidthName &&
        signedUploadInfo.height && signedUploadInfo.width) {
        this.setState({
          [fieldKey]: signedUploadInfo.fields.key,
          [field._inputVideoHeightName]: signedUploadInfo.height,
          [field._inputVideoWidthName] : signedUploadInfo.width
        })
      } else {
        this.setState({
          [fieldKey]: signedUploadInfo.fields.key
        })
      }
    }
  }

  handleColorChange = (color, id) => {
    this.setState({ [id]: color })
  }

  checkValidityIfDeleteMode = () => {
    if (this.props.formDefinition.formType === 'del' || this.props.formDefinition.formType === 'delete') {
      if (this.state.delete !== 'delete') {
        return true
      }
    }
    return false
  }

  doAction() {
    this.setState({
      inProcess: true, // Nothing should change while sumitting
      message: ''
    });

    const apiData = this.processValuesBeforeAction()
    if (!apiData) return
    this.submit(apiData)
  }

  isValid(current) {
    let valid = true;
    current.valid = true;
    if (current.v_required.value) {
      if (current.condition &&
        this.state[current.condition.key] !== current.condition.value) {
        // If condition doesnt match we can ignore this field.
        current.valid = true;
        // continue;
      } else if (current.multiSelect) {
        if (!this.state[current.key].length) {
          valid = false;
          current.valid = false;
        }
      } else {
        if (this.state[current.key] === '' || (this.state[current.key] && this.state[current.key].trim && this.state[current.key].trim() === '')) {
          valid = false;
          current.valid = false;
        }
      }
    }
    return valid
  }

  processValuesBeforeAction() {
    const apiData = Object.assign({}, this.props.apiData)
    let hasChange = false;
    let valid = true;
    delete apiData.REMOVE_ATTRS
    const REMOVE_ATTRS = []
    for (const current of this.fields) {
      this.isValid(current)
      if (!current.valid) valid = false
      apiData[current.key] = this.state[current.key];
      if (current.valueDisplayScale && apiData[current.key]) {
        apiData[current.key] =
          Math.round(apiData[current.key] * current.valueDisplayScale)
      }
      if (this.submitOnlyChanges) {
        if (this.state[current.key] !== this.previousState[current.key]) {
          hasChange = true;
        } else {
          delete apiData[current.key]
        }
      }
      const value = this.state[current.key];
      if (!current.v_required.value) {
        if (value !== this.previousState[current.key]) {
          if (value === '' || value === null || value === undefined) {
            REMOVE_ATTRS.push(current.key)
            delete apiData[current.key]
          }
        }
      }
    }
    if (REMOVE_ATTRS.length) {
      apiData.REMOVE_ATTRS = REMOVE_ATTRS
    }

    if (!valid) {
      this.setState({
        success: false,
        inProcess: false,
      });
      return null;
    }

    if (this.submitOnlyChanges && !hasChange && this.props.formDefinition.formType === 'edit') {
      this.setState({
        success: false,
        message: 'No changes',
        inProcess: false
      });
      return null;
    }

    if (this.checkValidityIfDeleteMode()) {
      this.setState({
        success: false,
        inProcess: false,
        message: Helper.getString('confirmDeleteMsg')
      });
      return null;
    }

    if (this.locations) {
      for (const key in this.locations) {
        apiData[key] = this.locations[key]
      }
    }
    return apiData;
  }

  submit(apiData) {
    if (this.props.customSubmit) {
      this.props.customSubmit({
        formType: this.props.formDefinition.formType,
        formData: apiData,
        caller: this
      }, () => {
        if (this.props.onClosed) {
          this.props.onClosed();
        }
      })
      return
    }
    ApiHelper.call(
      { method: this.props.apiMethod, endPoint: this.props.apiEndPoint, jsonBody: apiData },
      function (err, data) {
        if (err) {
          const errorMessage = Helper.getErrorMsg(err);
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: errorMessage,
            success: false,
            message: errorMessage,
            inProcess: false
          })
          return;
        }
        this.previousState = this.state;
        if (Helper.inArray(['delete', 'del'], this.props.formDefinition.formType)) {
          this.setState({
            success: true,
            message: '',
            inProcess: false
          })
          // if (this.props.onClosed) {
          //   this.props.onClosed();
          // }
          // if (this.props.onCompleteAction) {
          //   this.props.onCompleteAction()
          // }
        } else {
          this.setState({
            success: true,
            message: Helper.getString('successful'),
            inProcess: false
          })
        }
        if (this.props.onCompleteAction) {
          this.props.onCompleteAction({
            apiInvokeData: {
              method: this.props.apiMethod,
              endPoint: this.props.apiEndPoint,
              reqBody: apiData,
              responseBody: data
            }
          })
        }
      }.bind(this));
  }

  setFormControlParams(current, fromControlParams) {
    if (current.v_required.value) {
      fromControlParams.required = true;
    }
    if (!current.valid) {
      fromControlParams.error = true;
    }
  }

  render() {
    const leftFields = [];
    const rightFields = [];
    this.generateFields(leftFields, rightFields)
    return (
      <form key='form' autoComplete='off' className={css(Styles.form)}>
        {this.generateContent(leftFields, rightFields)}
        {this.generateActions()}
      </form>
    );
  }

  generateDeleteField() {
    const formControlParams = {};
    const current = {
      key: 'delete',
      label: 'Type "delete" for deletion',
    }
    const fieldParams = {
      id: current.key,
      value: this.state[current.key],
      fullWidth: true
    };

    return (
      <div className={(css(Styles.delFieldContainer))} key={current.key}>
        <FormControl className={css(Styles.formControlMain)} fullWidth {...formControlParams} >
          <p className={css(Styles.label)}>{current.label}</p>
          <TextField
            error={formControlParams.error}
            required={formControlParams.required}
            autoComplete='off'
            className={css(Styles.formControl, Styles.deleteInputBoxStyle)}
            {...fieldParams}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: css(Styles.textInputStyles),
                input: css(Styles.formInputStyle, Styles.deleteInputStyle),
              }
            }}
            onChange={this.handleDeleteFieldChange} />
        </FormControl>
      </div>
    )
  }

  generateFields(leftFields, rightFields) {
    for (const current of this.fields) {
      const formControlParams = {};
      let field;
      let errorTag = '';

      this.setFormControlParams(current, formControlParams);
      if (!current.valid) {
        errorTag = <FormHelperText>{current.v_required.err}</FormHelperText>;
      }
      if (current.condition) {
        if (current.condition.values) {
          if (!Helper.inArray(current.condition.values, this.state[current.condition.key])) {
            continue
          }
        } else if (current.condition.value) {
          if (this.state[current.condition.key] !== current.condition.value) {
            continue
          }
        }
      }
      if(current.hide) {
        continue
      }
      switch (current.type) {
      case 'edit_text':
      case 'document':
        field = this.generateEditText(current, formControlParams, errorTag)
        break;
      case 'rich_text':
        field = this.generateRichtext(current, formControlParams, errorTag)
        break;
      case 'radio':
      case 'check_box':
      case 'select':
        field = this.generateAutoCompleteSelection(current, formControlParams, errorTag)
        break;
      case 'dateTime':
        field = this.generateDateTimePicker(current, formControlParams, errorTag)
        break
      case 'dateTimeStr':
        field = this.generateDateTimePickerStr(current, formControlParams, errorTag)
        break
      case 'date':
        field = this.generateDatePicker(current, formControlParams, errorTag)
        break
      case 'year':
        field = this.generateYearPicker(current, formControlParams, errorTag)
        break
      case 'time':
        field = this.generateTimePicker(current, formControlParams, errorTag)
        break
      default:
        console.error(Helper.getString('unknownFieldType'), current.type)
        continue;
      }
      if (!current.placement) {
        current.placement = 'left' // default
      }
      if (current.placement === 'left') {
        leftFields.push(field);
      } else if (current.placement === 'right') {
        rightFields.push(field);
      }
    }
  }

  generateContent(leftFields, rightFields) {
    if (leftFields.length !== 0 && rightFields.length === 0) {
      return (
        <Grid container spacing={2}>
          {leftFields.map((item,index) => {
            return (
              <Grid key={'lefField_' + index} item xs={12}>
                {item}
              </Grid>
            )
          })
          }
        </Grid>
      )
    } else if (rightFields.length !== 0 && leftFields.length === 0) {
      return (
        <Grid container spacing={2}>
          {rightFields.map((item, index)  => {
            return (
              <Grid key={'rightField_' + index} item xs={12}>
                {item}
              </Grid>
            )
          })
          }
        </Grid>
      )
    }

    const combinedArray = []
    const lMin = Math.min(leftFields.length, rightFields.length);
    const lMax = Math.max(leftFields.length, rightFields.length);
    if (lMin === leftFields.length && lMin !== rightFields.length) {
      for (let i = 0; i < lMin - rightFields.length; i++) {
        leftFields.push('')
      }
    } else if (lMin === rightFields.length && lMin !== leftFields.length) {
      for (let i = 0; i < lMin - leftFields.length; i++) {
        rightFields.push('')
      }
    }
    for (let i = 0; i < lMax; i++) {
      combinedArray.push(leftFields[i], rightFields[i]);
    }

    // combinedArray.push(...leftFields.slice(l), ...rightFields.slice(l));

    return (
      <Grid container spacing={2}>
        {combinedArray.map((item, i) => {
          return (
            <Grid key={'grid-' + i} item xs={12} sm={6} md={6} lg={6}>
              {item}
            </Grid>
          )
        })
        }
      </Grid>
    )
  }

  generateContentOld(leftFields, rightFields) {
    if (rightFields.length > 0) {
      return <div>
        <Grid container>
          <Grid className={css(Styles.leftGridPadding)} item xs={12} sm={6}>
            {leftFields}
          </Grid>
          <Grid className={css(Styles.rightGridPadding)} item xs={12} sm={6}>
            {rightFields}
          </Grid>
        </Grid>
      </div>
    } else {
      return <div>
        <Grid container>
          <Grid item xs={12}>
            {leftFields}
          </Grid>
        </Grid>
      </div>
    }
  }

  generateActions() {
    let buttonText = this.props.formDefinition.ctaButtonText || 'Delete'
    let buttonStyle = Styles.buttonDelete
    if (Helper.inArray(['add', 'edit'], this.props.formDefinition.formType)) {
      buttonText = this.props.formDefinition.ctaButtonText || 'Save'
      buttonStyle = Styles.button
    } else if ('approve' === this.props.formDefinition.formType) {
      buttonText = 'Approve'
      buttonStyle = Styles.button
    }
    const dialogAction = <div className={css(Styles.actions)}>
      <span className={this.state.success ? css(Styles.successMsg) : css(Styles.errorMsg)}>
        {this.state.message}
      </span>
      {(this.props.formDefinition.formType === 'del' || this.props.formDefinition.formType === 'delete') &&
        this.generateDeleteField()
      }
      <AppButton
        buttonStyle={buttonStyle}
        disabled={this.state.inProcess}
        inProcess={this.state.inProcess}
        onClick={this.doAction}
        buttonText={buttonText}
      />
    </div>

    return dialogAction
  }

  componentDidMount() {
    for (const current of this.fields) {
      if (current.pickLoc) {
        this.initGooglePlaces(current)
      }
    }
  }

  initGooglePlaces(current) {
    const inputNode = document.getElementById(current.key);
    const autoComplete = new window.google.maps.places.Autocomplete(inputNode);
    autoComplete.setFields(['address_component', 'adr_address', 'name', 'formatted_address', 'geometry'])
    autoComplete.addListener('place_changed', () => {
      const place = autoComplete.getPlace();
      this.locations[current.locName] = {
        name: place.name,
        address: place.formatted_address,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }
      this.setState({
        [current.key]: place.formatted_address
      })
      // console.log('place:', place);
      //console.log(place.geometry.location.lat());
      //console.log(place.geometry.location.lng());
    });
  }

  generateRichtext(current, formControlParams, errorTag) {
    return (
      <div key={current.key}>
        <p className={css(Styles.label)}>{current.label}</p>
        <RichtextEditor
          current={current}
          fullEditor={current.fullEditor}
          value={this.state[current.key]}
          handleRichtextInputChange={this.handleRichtextInputChange} />
        {errorTag}
      </div>
    )
  }

  getCharCounter(current, fieldParams) {
    if (current.showCharCounter) {
      return (<p className={css(Styles.charCounter)}>
        {fieldParams.value.length}{current.v_max && current.v_max.value && '/' + current.v_max.value}</p>)
    }
  }

  generateEditText(current, formControlParams, errorTag) {
    const fieldParams = {
      id: current.key,
      value: this.state[current.key],
      fullWidth: true
    };
    if (current.multiline) {
      fieldParams.multiline = current.multiline;
      fieldParams.rows = current.rows || 5;
    }
    fieldParams.disabled = this.shouldDisable(current)
    return <div key={current.key}>
      <FormControl className={css(Styles.formControlMain)} fullWidth {...formControlParams} >
        {current.inputFileLink ?
          <div className={css(Styles.linkLabelContainer)}>
            <p className={css(Styles.label)}>{current.label}</p>
            <span className={css(Styles.label)}>|</span>
            {current.inputFileLink && (
              <a
                href={current.inputFileLink}
                target='_blank'
                className={css(Styles.linkLabel)}
              >
                {current.inputFileLinkLabel || 'Download Sample Input File'}
              </a>
            )}
          </div>
          :
          <p className={css(Styles.label)}>{current.label}</p>
        }
        {(!current.imageUpload && !current.documentUpload && !current.colourPicker && !current.mediaPicker) &&
          <TextField
            error={formControlParams.error}
            required={formControlParams.required}
            variant={'standard'}
            className={css(Styles.formControl)}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: this.shouldDisable(current) ? css([Styles.textInputStyles, Styles.textInputStylesDisabled]) : css(Styles.textInputStyles),
                input: css(Styles.formInputStyle, Styles.textInput),
              }
            }}
            inputProps={{
              maxLength: current.showCharCounter && current.v_max && current.v_max.value,
            }}
            helperText={this.getCharCounter(current, fieldParams)}
            FormHelperTextProps={{
              className: css(Styles.textFieldHelperText)
            }}
            autoComplete='off'
            {...fieldParams}
            onChange={this.handleInputChange} />
        }
        {current.imageUpload &&
          <Fragment>
            {this.props.customFormComponents && this.props.customFormComponents.imageUpload ?
              <this.props.customFormComponents.imageUpload.comp
                uploadId={current.key}
                url={current.link}
                onUploadSuccess={this.handleUploadSuccess.bind(this)}
                width={current.imageWidth}
                height={current.imageHeight}
                uploadType={current.uploadType}
                uploadAccept={current.uploadAccept}
                uploadLocation={this.props.uploadLocation}
                orgId={this.props.orgId}
                uploadExt={current.uploadExt}
                mode={current.mode}
                borderRadius={0}
                disabled={this.shouldDisable(current)}
                {...this.props.customFormComponents.imageUpload.props}
              />
              :
              <ImageUploader
                uploadId={current.key}
                url={current.link}
                onUploadSuccess={this.handleUploadSuccess.bind(this)}
                width={current.imageWidth}
                height={current.imageHeight}
                uploadType={current.uploadType}
                uploadAccept={current.uploadAccept}
                uploadLocation={this.props.uploadLocation}
                orgId={this.props.orgId}
                uploadExt={current.uploadExt}
                mode={current.mode}
                borderRadius={0}
                disabled={this.shouldDisable(current)}
                setStateKeyValueHandler={this.setStateKeyValue.bind(this)}
                autoFillTitleKey={current.autoFillTitleKey}
                autoFillTitleValue={this.state[current.autoFillTitleKey] || null}
                selectedImageDimension={this.props.selectedImageDimension}
              />
            }
          </Fragment>
        }
        {current.documentUpload &&
          <DocumentUploader
            label={current.label}
            uploadId={current.key}
            link={current.link}
            uploadType={current.uploadType}
            uploadAccept={current.uploadAccept}
            uploadLocation={this.props.uploadLocation}
            uploadExt={current.uploadExt}
            fileSizeLimit={current.fileSizeLimit}
            onUploadSuccess={this.handleUploadSuccess.bind(this)}
            value={this.state[current.key]}
            disabled={this.shouldDisable(current)}
            autoFillVideoDuration={current.autoFillVideoDuration}
            maxVideoDuration={current.maxVideoDuration}
            maxWidthOrHeight={current.maxWidthOrHeight}
            autoFillField={current.autoFillField}
            setStateKeyValueHandler={this.setStateKeyValue.bind(this)}
            autoFillTitleKey={current.autoFillTitleKey}
            autoFillTitleValue={this.state[current.autoFillTitleKey] || null}
            mode={current.mode}
            width={current.videoWidth}
            height={current.videoHeight}
          />
        }
        {current.mediaPicker && this.props.customFormComponents && this.props.customFormComponents.assetPicker && this.props.customFormComponents.assetPicker.comp &&
          <this.props.customFormComponents.assetPicker.comp
            updateField={current.key}
            onSelectSuccess={this.handleUploadSuccess.bind(this)}
            orgId={this.props.orgId}
            borderRadius={0}
            disabled={this.shouldDisable(current)}
            {...current}
            {...this.props.customFormComponents.assetPicker.props}
          />
        }
        {current.colourPicker &&
          <ColourPicker
            id={current.key}
            value={this.state[current.key]}
            handleColorChange={this.handleColorChange} />
        }
        {errorTag}
      </FormControl>
      {this.generatePendingApproval(current)}
    </div>
  }
  setStateKeyValue(options) {
    this.setState({ [options.key]: options.value });
  }
  generateDateTimePicker(current, formControlParams, errorTag) {
    return (
      <Fragment key={current.key}>
        <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
          <p className={css(Styles.label)}>{current.label}</p>
          <DateTimePicker
            keyboard
            variant={'standard'}
            keyboardIcon={<i className='material-icons-outlined' >calendar_today</i>}
            format='DD-MMM-YYYY hh:mm A'
            placeholder='DD-MMM-YYYY hh:mm A'
            value={this.state[current.key] || null}
            onChange={this.handleDateChange(current)}
            animateYearScrolling={false}
            clearable={current.clearable}
            margin='normal'
            fullWidth
            disabled={this.shouldDisable(current)}
            className={css(Styles.pickerStyle)}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: this.shouldDisable(current) ? css([Styles.pickerInputStyles, Styles.textInputStylesDisabled]) : css(Styles.pickerInputStyles),
                input: css(Styles.formInputStyle),
              }
            }}
            DialogProps={{
              className: css(Styles.dialog),
              PaperProps: {
                className: css(Styles.paper)
              }
            }}
            {...formControlParams}
          />
        </MuiPickersUtilsProvider>
        {errorTag}
      </Fragment>
    )
  }

  generateDateTimePickerStr(current, formControlParams, errorTag) {

    const handleDateChangeStr = (current) => (date) => {
      if (!date) {
        this.setState({
          [current.key]: ''
        });
      } else {
        const formattedDate = date.format('DD-MMM-YYYY hh:mm A');
        this.setState({
          [current.key]: formattedDate
        });
      }
    };

    // const handleInputChange = (e) => {
    //   const inputValue = e.target.value;
    //   if (!inputValue) {
    //     this.setState({
    //       [current.key]: ''
    //     });
    //   }
    // };

    return (
      <Fragment key={current.key}>
        <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
          <p className={css(Styles.label)}>{current.label}</p>
          <DateTimePicker
            keyboard
            variant={'standard'}
            keyboardIcon={<i className='material-icons-outlined' >calendar_today</i>}
            format='DD-MMM-YYYY hh:mm A'
            placeholder='DD-MMM-YYYY hh:mm A'
            value={this.state[current.key] ? moment(this.state[current.key], 'DD-MMM-YYYY hh:mm A') : null}
            onChange={handleDateChangeStr(current)}
            disablePast={current.disablePast ? true : false}
            {...(current.disablePast ? { minDateMessage: '' } : {})}
            // onInputChange={handleInputChange}
            animateYearScrolling={false}
            clearable={current.clearable}
            margin='normal'
            fullWidth
            disabled={this.shouldDisable(current)}
            className={css(Styles.pickerStyle)}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: this.shouldDisable(current) ? css([Styles.pickerInputStyles, Styles.textInputStylesDisabled]) : css(Styles.pickerInputStyles),
                input: css(Styles.formInputStyle),
              }
            }}
            DialogProps={{
              className: css(Styles.dialog),
              PaperProps: {
                className: css(Styles.paper)
              }
            }}
            {...formControlParams}
          />
        </MuiPickersUtilsProvider>
        {errorTag}
      </Fragment>
    )
  }

  generateDatePicker(current, formControlParams, errorTag) {
    return (
      <Fragment key={current.key}>
        <MuiPickersUtilsProvider utils={MomentUtils} moment={moment} >
          <p className={css(Styles.label)}>{current.label}</p>
          <DatePicker
            variant={'standard'}
            keyboard
            disablePast={current.disablePast}
            //minDateMessage='' //to hide default error message if disabledPast is enabled
            keyboardIcon={<i className='material-icons-outlined' >calendar_today</i>}
            format='DD-MMM-YYYY'
            placeholder='DD-MMM-YYYY'
            value={this.state[current.key] || null}
            onChange={this.handleDateChange(current)}
            animateYearScrolling={false}
            clearable={current.clearable}
            margin='normal'
            fullWidth
            disabled={this.shouldDisable(current)}
            className={css(Styles.pickerStyle)}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: this.shouldDisable(current) ? css([Styles.pickerInputStyles, Styles.textInputStylesDisabled]) : css(Styles.pickerInputStyles),
                input: css(Styles.formInputStyle),
              }
            }}
            DialogProps={{
              className: css(Styles.dialog),
              PaperProps: {
                className: css(Styles.paper)
              }
            }}
            {...formControlParams}
          />
        </MuiPickersUtilsProvider>
        {errorTag}
      </Fragment>
    )
  }

  generateYearPicker(current, formControlParams, errorTag) {
    return (
      <Fragment key={current.key}>
        <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
          <p className={css(Styles.label)}>{current.label}</p>
          <DatePicker
            variant={'standard'}
            views={['year']}
            keyboard
            keyboardIcon={<i className='material-icons-outlined' >calendar_today</i>}
            format='YYYY'
            placeholder='YYYY'
            value={this.state[current.key] || null}
            onChange={this.handleDateChange(current)}
            animateYearScrolling={false}
            clearable={current.clearable}
            margin='normal'
            fullWidth
            disabled={this.shouldDisable(current)}
            className={css(Styles.pickerStyle)}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: this.shouldDisable(current) ? css([Styles.pickerInputStyles, Styles.textInputStylesDisabled]) : css(Styles.pickerInputStyles),
                input: css(Styles.formInputStyle),
              }
            }}
            DialogProps={{
              className: css(Styles.dialog),
              PaperProps: {
                className: css(Styles.paper)
              }
            }}
            {...formControlParams}
          />
        </MuiPickersUtilsProvider>
        {errorTag}
      </Fragment>
    )
  }

  generateTimePicker(current, formControlParams, errorTag) {
    return (
      <Fragment key={current.key}>
        <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
          <p className={css(Styles.label)}>{current.label}</p>
          <TimePicker
            keyboard
            variant={'standard'}
            keyboardIcon={<i className='material-icons-outlined' >schedule</i>}
            placeholder='hh:mm A'
            value={this.state[current.key] || null}
            onChange={this.handleDateChange(current)}
            disableOpenOnEnter
            clearable={current.clearable}
            margin='normal'
            fullWidth
            disabled={this.shouldDisable(current)}
            className={css(Styles.pickerStyle)}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: this.shouldDisable(current) ? css([Styles.pickerInputStyles, Styles.textInputStylesDisabled]) : css(Styles.pickerInputStyles),
                input: css(Styles.formInputStyle),
              }
            }}
            DialogProps={{
              className: css(Styles.dialog),
              PaperProps: {
                className: css(Styles.paper)
              }
            }}
            {...formControlParams}
          />
        </MuiPickersUtilsProvider>
        {errorTag}
      </Fragment>
    )
  }

  handleDateChange = current => date => {
    current.valid = true;
    if (!date) {
      return this.setState({
        [current.key]: null
      });
    }
    this.setState({
      [current.key]: date.utc().valueOf()
    });
  }

  generateSelection(current, formControlParams, errorTag) {
    const options = [];
    for (const option of current.options) {
      let cbOption = '';
      if (current.multiSelect) {
        cbOption = <Checkbox color='primary' checked={this.state[current.key].indexOf(option.key) > -1} />
      }
      options.push(
        <MenuItem key={option.key} value={option.key}>
          {cbOption}
          {option.text || option.label}
        </MenuItem>
      );
    }
    let renderParams = {};
    if (current.multiSelect) {
      const searchOptions = current.options;
      renderParams = {
        renderValue: selected => (
          <div className={css(Styles.chips)}>
            {selected.map(value => { return this.findValueInList(value, searchOptions) })}
          </div>
        )
      }
    }
    return <FormControl className={css(Styles.formControlMain)} key={current.key} fullWidth {...formControlParams} variant='outlined'>
      <InputLabel htmlFor={current.label}>{current.label}</InputLabel>
      <Select
        multiple={current.multiSelect}
        value={this.state[current.key] ? this.state[current.key] : current.value}
        onChange={this.handleSelectChange}
        {...renderParams}
        input={<OutlinedInput name={current.key} id={current.key} disabled={this.shouldDisable()} label={current.label} />}
      >
        {options}
      </Select>
      {errorTag}
      {this.generatePendingApproval(current)}
    </FormControl>
  }

  findValueInList(value, searchOptions) {
    const found = searchOptions.find(o => o.key === value)
    if (found) {
      return (<Chip key={value} label={found.text || found.label} />)
    }
  }

  renderDynamicOption(current, option) {
    if (current.optionDisplayFields && current.optionDisplayFields.length) {
      return (
        <div className={css(Styles.dropdownOptionCard)}>
          {current.optionDisplayFields.map((field) => {
            const fieldKey = field.key
            const label = field.label

            if (!option[fieldKey]) {
              return null
            }

            return (
              <div key={fieldKey} className={css(Styles.dropdownOptionLine, field.bold && Styles.dropdownOptionLineBold)}>
                {label ? `${label}: ${option[fieldKey]}` : option[fieldKey]}
              </div>
            )
          })}
        </div>
      )
    }

    return (<div className={(option && !option.key) ? css(Styles.addOptionStyle) : ''} >{option.text || option.label}</div>)
  }

  generateAutoCompleteSelection(current, formControlParams, errorTag) {
    const value = this.processValueToPreFill(current)
    const filter = createFilterOptions();
    const fieldParams = {
      fullWidth: true,
      multiple: current.multiSelect,
      options: current.options,
      value: value
    };
    fieldParams.disabled = this.shouldDisable(current)

    // ADD OPTION
    if (current.addOptions === true) {
      const addPrefixText = this.props.formDefinition.addPrefix || 'Create'
      fieldParams.closeIcon = null
      fieldParams.loading = this.state.formFieldUpdateProgress !== current.key
      fieldParams.loadingText =  this.props.formDefinition.loadingText || Helper.getString('optionListLoadingText')
      fieldParams.filterOptions = (options, params) => {
        const filtered = filter(options, params);
        const { inputValue } = params;
        // Suggest the creation of a new value
        const isExisting = options.some((option) => inputValue === option.text || option.label);
        if (inputValue !== '' && !isExisting) {
          filtered.unshift({
            value: inputValue,
            text: `${addPrefixText} "${inputValue}"`,
          });
        }
        return filtered;
      }
    }
    return <form autoComplete='off'>
      <FormControl className={css(Styles.formControlMain)} fullWidth {...formControlParams} >
        <p className={css(Styles.label)}>{current.label}</p>
        <Autocomplete
          {...fieldParams}
          onChange={(e, val) => this.onAutoCompleteChange(val, current)}
          getOptionLabel={(option) => option.label || option.text}
          ChipProps={{
            deleteIcon: <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
              <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
            </svg>
          }}

          renderOption={(option) => {
            if (current.optionDisplayFields && current.optionDisplayFields.length) {
              return this.renderDynamicOption(current, option)
            }
            return (<div className={(option && !option.key) ? css(Styles.addOptionStyle) : ''} >{option.text || option.label}</div>)
          }}

          // renderOption={option => {
          //   return (
          //     <React.Fragment>
          //       {current.showThumbnail &&
          //         <React.Fragment>
          //           {option.img ?
          //             <div key={option.key} className={css(Styles.optionImageContainer, Styles.optionImageContainerSpec)}>
          //               <img width={20} height={20} src={option.img} className={css(Styles.optionImage)} />
          //             </div>
          //             :
          //             <div key={option.key} className={css(Styles.optionImageContainer, Styles.optionImageContainerSpec)}>
          //               <ImageIcon className={css(Styles.optionImage)} />
          //             </div>
          //           }
          //         </React.Fragment>
          //       }
          //       {option.label || option.text}
          //     </React.Fragment>
          //   )
          // }}
          classes={{
            tag: css(Styles.tag),
            popupIndicator: css(Styles.popupIndicator),
            popper: css(Styles.dialog)
          }}
          renderInput={params =>
            <TextField
              error={formControlParams.error}
              required={formControlParams.required}
              {...params}
              variant={'standard'}
              className={css(Styles.formControl)}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
                classes: {
                  root: this.shouldDisable(current) ? css([Styles.textInputStyles, Styles.textInputStylesDisabled]) : css(Styles.textInputStyles),
                  input: css(Styles.formInputStyle, Styles.textInput),
                },
                endAdornment: (
                  <React.Fragment>
                    {(this.state.formFieldUpdateProgress && this.state.formFieldUpdateProgress === current.key) ? <CircularProgress className={css(Styles.optionLoaderSpinner)} color='inherit' size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
                // startAdornment: (
                //   current.showThumbnail &&
                //   <InputAdornment position='start' className={css(Styles.inputAdornment)}>
                //     {fieldParams.options.map((item, index) => {
                //       if (item.img && item.key === fieldParams.value.key) {
                //         return (
                //           <div key={item.key} className={css(Styles.optionImageContainer)}>
                //             <img width={20} height={20} src={item.img} className={css(Styles.optionImage)} />
                //           </div>
                //         )
                //       } else if (item.key === fieldParams.value.key) {
                //         return (
                //           <div key={item.key} className={css(Styles.optionImageContainer)}>
                //             <ImageIcon className={css(Styles.optionImage)} />
                //           </div>
                //         )
                //       }
                //     })}
                //     {params.InputProps.startAdornment}
                //   </InputAdornment>
                // )

              }} />}
        />
        {errorTag}
        {this.generatePendingApproval(current)}
      </FormControl>
    </form>
  }

  processValueToPreFill = (current) => {
    let value
    if (current.multiSelect) {

      if (!this.state[current.key] || !current.options) return []

      value = []
      for (const k of this.state[current.key]) {
        for (const o of current.options) {
          if (o.key === k) {
            value.push({
              key: o.key,
              text: o.label || o.text
            })
          }
        }
      }
    } else {

      if (!this.state[current.key] || !current.options) return ''

      for (const o of current.options) {
        if ((o.key === this.state[current.key]) || (o.key === String(this.state[current.key]))) {
          value = {
            key: o.key,
            text: o.label || o.text
          }
        }
      }
    }
    return value
  }
  onAutoCompleteChange = async(value, current) => {
    // Calling the AddOptionHook
    let errorMessage = ''
    const newlyAddedOption = current.multiSelect ? value.find(obj => !obj.key) : (value && !value.key) ? value : undefined
    if (newlyAddedOption && current.addOptions) {
      current.disabled = true
      this.setState({formFieldUpdateProgress:current.key})
      // NOTE: We're assigning an '  ' value to the text box since there's no key present. This ensures that autocomplete displays nothing until we replace the option after the API call. This issue arises with single-select, as the default behavior selects the value when the key is an empty string ('').
      if (!current.multiSelect) this.setState({[current.key]:'   '})
      try{
        const updatedOptionsList = await this.props.onFormFieldOptionAdd({
          formField: current,
          value: newlyAddedOption.value,
          formId: this.props.formDefinition.formId
        })
        // Removing temp added option and geting rest options
        const removedTempOptions = current.multiSelect ? value.filter(obj => obj.key) : {}
        // Find out the new added option object
        let newOption = {}
        if (updatedOptionsList && updatedOptionsList.items && updatedOptionsList.items.length > 0) {
          updatedOptionsList.items.forEach((x) => {
            if ((x.label || x.text || x.title) === newlyAddedOption.value) newOption = { key: x.key || x.id, text: (x.label || x.text || x.title) }
          })
        }
        // Updating the existing selected options list with newly added obj
        value = current.multiSelect ? (Object.keys(newOption).length > 0 ? [...removedTempOptions, newOption] : [...removedTempOptions]) : newOption;
        if (this.state.formFieldUpdateProgress !== null) this.setState({formFieldUpdateProgress:null})
        current.disabled = false
      } catch(err) {
        if(err) console.log(err)
        errorMessage = Helper.getErrorMsg(err)
        if (this.state.formFieldUpdateProgress !== null) this.setState({formFieldUpdateProgress:null})
        current.disabled = false
      }
    }
    this.fields.find(o => o.key === current.key).valid = true;
    if (!current.multiSelect) {
      this.setState({
        [current.key]: (value && value.key) || ''
      })
    } else if (value) {
      const valDictByKey = {}
      const vals = []
      for (const v of value) {
        if (!valDictByKey[v.key]) {
          valDictByKey[v.key] = true
          vals.push(v.key)
        }
      }
      if (errorMessage) {
        current.valid = false
        current.v_required.err = errorMessage
      }
      this.setState({
        [current.key]: vals
      })
    }
  }

  generatePendingApproval(current) {
    return current.pendingApproval ? <p className={css(Styles.pendingApprovalLabel)}>{Helper.getString('pendingAppr')}</p> : ''
  }

  shouldDisable(current) {
    // if (Helper.inArray(['add'], this.props.formDefinition.formType)) return false
    if (current && current.v_condition && current.v_condition.type && current.v_condition.type === 'disable' && current.v_condition.key && this.state[current.v_condition.key] === current.v_condition.value) {
      return true
    }
    if (current && current.disabled && this.props.formDefinition.formType !== 'add') {
      return true
    }
    if (this.props.formDefinition.disableAlwaysFormFields && this.props.formDefinition.disableAlwaysFormFields.indexOf(current.key) > -1) {
      return true
    }
    if (Helper.inArray(['delete', 'del'], this.props.formDefinition.formType)) {
      return true
    }
    return Helper.inArray(['delete', 'del', 'approve'], this.props.formDefinition.formType) ||
      this.state.inProcess
  }
}

const Styles = (AppConfig.CUSTOM_STYLE || AppConfig.CUSTOM_STYLE_COMP.includes('DynamicForm')) ? CustomDynamicFormStyles : StyleSheet.create({
  form: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // padding: AppTheme.pagePadding,
    '@media (max-width: 320px)': {
      maxWidth: 300,
    }
  },
  leftGridPadding: {
    paddingRight: 10,
    '@media (max-width: 767px)': {
      paddingRight: 0,
    }
  },
  rightGridPadding: {
    paddingLeft: 10,
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  errorMsg: {
    paddingRight: 20,
    color: '#f44336'
  },
  successMsg: {
    paddingRight: 20,
    color: 'green'
  },
  marginLeft: {
    color: 'white'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 20,
    marginBottom: 30
  },
  pendingApprovalLabel: {
    marginTop: 0,
    marginBottom: 0,
    color: 'orange',
    fontSize: 10
  },
  openDoc: {
    marginTop: 0,
    marginBottom: 0,
    color: 'black',
    fontSize: 10,
    cursor: 'pointer',
  },
  uploadFieldLabel: {
    marginTop: 10,
  },
  buttonDelete: {
    backgroundColor: '#FF0D0D'
  },
  label: {
    fontSize: 14,
    color: 'grey',
    margin: 0,
    marginBottom: 8
  },
  linkLabel: {
    fontSize: 14,
    margin: 0,
    marginBottom: 8,
    color: '#2029f1',
    textDecoration: 'none'
  },
  linkLabelContainer: {
    display: 'flex',
    gap: 5
  },
  formControl: {
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden'
  },
  textInput: {
    padding: '4px 0px'
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16
  },
  textInputStylesDisabled: {
    backgroundColor: '#f5f5f5',
  },
  pickerStyle: {
    marginTop: 0
  },
  pickerInputStyles: {
    padding: '8px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16,
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden'
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  tag: {
    backgroundColor: AppTheme.secondaryColor,
    color: '#222222',
    fontSize: 13,
    borderRadius: 8,
    height: 26
  },
  popupIndicator: {
    marginRight: 5,
  },
  dialog: {
    zIndex: 130000,
    fontSize: 16,
    color: '#222222',
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
  },

  modalCloseIcon: {
    width: 12,
    height: 12,
    padding: 1,
    borderRadius: 6
  },

  fieldOuterContainer: {
    display: 'flex'
  },
  fieldLeftInnerContainer: {
    flex: 1,
    paddingRight: 10,
    '@media (max-width: 767px)': {
      paddingRight: 0,
    }
  },
  fieldRightInnerContainer: {
    flex: 1,
    paddingLeft: 10,
    '@media (max-width: 767px)': {
      paddingLeft: 0,
    }
  },
  delFieldContainer: {
    width: '25%',
    marginRight: 20
  },
  formControlMain: {
    marginTop: 0,
    marginBottom: 0
  },
  optionImageContainer: {
    width: 20,
    height: 20,
  },
  optionImage: {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%'
  },
  optionImageContainerSpec: {
    marginRight: 9,
    marginLeft: 5
  },
  textFieldHelperText: {
    color: '#000000',
    fontSize: 14,
    alignSelf: 'flex-end',
    position: 'absolute',
    right: 10,
    bottom: 0
  },
  charCounter: {
    margin: 0
  },
  deleteInputStyle:{
    height: 8
  },
  optionLoaderSpinner:{
    marginRight: 15
  },
  addOptionStyle: {
    color: AppTheme.buttonBg
  },
  deleteInputBoxStyle:{},
  dropdownOptionCard: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 14,
    padding: '18px 22px',
    border: '1px solid #E5E5E5',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
  },
  dropdownOptionTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: '#222222',
    marginBottom: 12
  },
  dropdownOptionLine: {
    fontSize: 14,
    color: '#555555',
    marginBottom: 6,
    lineHeight: '20px'
  },
  dropdownOptionLineBold: {
    fontWeight: 'bold'
  }
})



// WEBPACK FOOTER //
// ./src/common/components/DynamicForm.js